import React, { useReducer, useContext, useEffect } from "react";

import reducer from "./reducer";
import axios from "axios";
import {
  DISPLAY_ALERT,
  CLEAR_ALERT,
  SETUP_USER_BEGIN,
  SETUP_USER_SUCCESS,
  SETUP_USER_ERROR,
  TOGGLE_SIDEBAR,
  LOGOUT_USER,
  UPDATE_USER_BEGIN,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  HANDLE_CHANGE,
  CLEAR_VALUES,
  GET_PRODUCTS_BEGIN,
  GET_PRODUCTS_SUCCESS,
  CREATE_JOB_BEGIN,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_ERROR,
  GET_JOBS_BEGIN,
  GET_JOBS_SUCCESS,
  SET_EDIT_JOB,
  DELETE_JOB_BEGIN,
  DELETE_JOB_ERROR,
  EDIT_JOB_BEGIN,
  EDIT_JOB_SUCCESS,
  EDIT_JOB_ERROR,
  SHOW_STATS_BEGIN,
  SHOW_STATS_SUCCESS,
  CLEAR_FILTERS,
  CHANGE_PAGE,
  GET_CURRENT_USER_BEGIN,
  GET_CURRENT_USER_SUCCESS,
  ADD_PRODUCT_TO_CART_BEGIN,
  ADD_PRODUCT_TO_CART_SUCCESS,
  SET_PRODUCT_TO_CART,
  REMOVE_PRODUCT_TO_CART_BEGIN,
  REMOVE_PRODUCT_TO_CART_SUCCESS,
  CLEAR_CART_BEGIN,
  CLEAR_CART_SUCCESS,
  CC_PAYMENT_BEGIN,
  CC_PAYMENT_SUCCESS,
  CC_PAYMENT_ERROR,
} from "./actions";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const initialState = {
  accessToken: "",
  userLoading: true,
  isLoading: false,
  showAlert: false,
  alertText: "",
  alertType: "",
  user: null,
  userLocation: "",
  showSidebar: false,
  isEditing: false,
  editJobId: "",
  position: "",
  company: "",
  jobLocation: "",
  jobTypeOptions: ["full-time", "part-time", "remote", "internship"],
  jobType: "full-time",
  statusOptions: ["interview", "declined", "pending"],
  status: "pending",

  shoppingCart: localStorage.getItem("shoppingCart")
    ? JSON.parse(localStorage.getItem("shoppingCart"))
    : [],

  products: [],
  totalProducts: 0,

  jobs: [],
  totalJobs: 0,
  numOfPages: 1,
  page: 1,
  stats: {},
  monthlyApplications: [],
  search: "",
  searchStatus: "all",
  searchType: "all",
  sort: "latest",
  sortOptions: ["latest", "oldest", "a-z", "z-a"],
};

const AppContext = React.createContext();

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  // axios
  const authFetch = axios.create({
    baseURL: `${API_URL}`,
  });

  authFetch.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // console.log(error.response)
      if (error.response.status === 401) {
        logoutUser();
      }
      return Promise.reject(error);
    },
  );

  const displayAlert = () => {
    dispatch({ type: DISPLAY_ALERT });
    clearAlert();
  };

  const clearAlert = () => {
    setTimeout(() => {
      dispatch({ type: CLEAR_ALERT });
    }, 3000);
  };

  const setupUser = async ({ currentUser, endPoint, alertText }) => {
    dispatch({ type: SETUP_USER_BEGIN });
    try {
      const { data } = await axios.post(
        `${API_URL}/auth/${endPoint}`,
        currentUser,
      );
      console.log("Debug");
      console.log(data.access_token);
      dispatch({
        type: SETUP_USER_SUCCESS,
        payload: {
          user: { name: "Dummy" },
          accessToken: data.access_token,
          alertText,
        },
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: SETUP_USER_ERROR,
        payload: { msg: error.response.data.message },
      });
    }
    clearAlert();
  };

  const toggleSidebar = () => {
    dispatch({ type: TOGGLE_SIDEBAR });
  };

  const logoutUser = async () => {
    dispatch({ type: LOGOUT_USER });
  };

  const updateUser = async (currentUser) => {
    dispatch({ type: UPDATE_USER_BEGIN });
    try {
      const headers = {
        Authorization: `Bearer ${state.accessToken}`,
      };
      const { data } = await authFetch.patch(
        `${API_URL}/users/profile`,
        currentUser,
        {
          headers: headers,
        },
      );
      const user = data;

      dispatch({
        type: UPDATE_USER_SUCCESS,
        payload: {},
      });
    } catch (error) {
      if (error.response.status !== 401) {
        dispatch({
          type: UPDATE_USER_ERROR,
          payload: { msg: error.response.data.msg },
        });
      }
    }
    clearAlert();
  };

  const updateProfileImage = async (currentUser, location) => {};

  const handleChange = ({ name, value }) => {
    dispatch({ type: HANDLE_CHANGE, payload: { name, value } });
  };
  const clearValues = () => {
    dispatch({ type: CLEAR_VALUES });
  };

  /* Products */
  const getProducts = async () => {
    dispatch({ type: GET_PRODUCTS_BEGIN });
    try {
      const headers = {
        Authorization: `Bearer ${state.accessToken}`,
      };
      const { data } = await axios.get(`${API_URL}/ecommerce/product-list`, {
        headers,
      });
      const products = data;
      dispatch({
        type: GET_PRODUCTS_SUCCESS,
        payload: {
          products,
        },
      });
    } catch (error) {
      console.log(error);
    }
    clearAlert();
  };

  /* Shopping Cart */
  const addProduct = async (product) => {
    console.log("addProduct");
    try {
      dispatch({
        type: ADD_PRODUCT_TO_CART_SUCCESS,
        payload: {
          product,
        },
      });
    } catch (error) {
      console.log(error);
    }
    clearAlert();
  };

  const setProducts = async (products) => {
    try {
      dispatch({
        type: SET_PRODUCT_TO_CART,
        payload: {
          products,
        },
      });
    } catch (error) {
      console.log(error);
    }
    clearAlert();
  };

  const removeProduct = async (product) => {};

  const clearAllProduct = async () => {};

  /* Checkout */
  const ccPayment = async (cardholderName, cardNumber, expiration, cvv) => {
    try {
      dispatch({ type: CC_PAYMENT_BEGIN });
      const headers = {
        Authorization: `Bearer ${state.accessToken}`,
      };
      const resp = await authFetch.post(
        `${API_URL}/ecommerce/cc-payment`,
        {
          cardholderName: cardholderName,
          cardNumber: cardNumber,
          expiration: expiration,
          cvv: cvv,
        },
        {
          headers: headers,
        },
      );
      dispatch({ type: CC_PAYMENT_SUCCESS });
      dispatch({ type: CLEAR_VALUES });
      return resp.data;
    } catch (error) {
      if (error.response.status === 401) return;
      dispatch({
        type: CC_PAYMENT_ERROR,
        payload: { msg: error.response.data.msg },
      });
      return error.response.data;
    }
    clearAlert();
  };

  /* Jobs */
  const createJob = async () => {
    dispatch({ type: CREATE_JOB_BEGIN });
    try {
      const { position, company, jobLocation, jobType, status } = state;
      await authFetch.post(`${API_URL}/jobs`, {
        position,
        company,
        jobLocation,
        jobType,
        status,
      });
      dispatch({ type: CREATE_JOB_SUCCESS });
      dispatch({ type: CLEAR_VALUES });
    } catch (error) {
      if (error.response.status === 401) return;
      dispatch({
        type: CREATE_JOB_ERROR,
        payload: { msg: error.response.data.msg },
      });
    }
    clearAlert();
  };
  const getJobs = async () => {
    const { page, search, searchStatus, searchType, sort } = state;

    let url = `${API_URL}/jobs?page=${page}&status=${searchStatus}&jobType=${searchType}&sort=${sort}`;
    if (search) {
      url = url + `&search=${search}`;
    }
    dispatch({ type: GET_JOBS_BEGIN });
    try {
      const { data } = await authFetch(url);
      const { jobs, totalJobs, numOfPages } = data;
      dispatch({
        type: GET_JOBS_SUCCESS,
        payload: {
          jobs,
          totalJobs,
          numOfPages,
        },
      });
    } catch (error) {
      logoutUser();
    }
    clearAlert();
  };
  const setEditJob = (id) => {
    dispatch({ type: SET_EDIT_JOB, payload: { id } });
  };
  const editJob = async () => {
    dispatch({ type: EDIT_JOB_BEGIN });

    try {
      const { position, company, jobLocation, jobType, status } = state;
      await authFetch.patch(`/jobs/${state.editJobId}`, {
        company,
        position,
        jobLocation,
        jobType,
        status,
      });
      dispatch({ type: EDIT_JOB_SUCCESS });
      dispatch({ type: CLEAR_VALUES });
    } catch (error) {
      if (error.response.status === 401) return;
      dispatch({
        type: EDIT_JOB_ERROR,
        payload: { msg: error.response.data.msg },
      });
    }
    clearAlert();
  };
  const deleteJob = async (jobId) => {
    dispatch({ type: DELETE_JOB_BEGIN });
    try {
      await authFetch.delete(`/jobs/${jobId}`);
      getJobs();
    } catch (error) {
      if (error.response.status === 401) return;
      dispatch({
        type: DELETE_JOB_ERROR,
        payload: { msg: error.response.data.msg },
      });
    }
    clearAlert();
  };
  const showStats = async () => {
    dispatch({ type: SHOW_STATS_BEGIN });
    try {
      const { data } = await authFetch("/jobs/stats");
      dispatch({
        type: SHOW_STATS_SUCCESS,
        payload: {
          stats: data.defaultStats,
          monthlyApplications: data.monthlyApplications,
        },
      });
    } catch (error) {
      logoutUser();
    }
    clearAlert();
  };
  const clearFilters = () => {
    dispatch({ type: CLEAR_FILTERS });
  };
  const changePage = (page) => {
    dispatch({ type: CHANGE_PAGE, payload: { page } });
  };

  const getCurrentUser = async () => {
    dispatch({ type: GET_CURRENT_USER_BEGIN });
    try {
      const { data } = await authFetch("/auth/getCurrentUser");
      const { user, location } = data;

      dispatch({
        type: GET_CURRENT_USER_SUCCESS,
        payload: { user, location },
      });
    } catch (error) {
      if (error.response && error.response.status === 401) return;
      logoutUser();
    }
  };

  useEffect(() => {
    getCurrentUser();
  }, []);

  return (
    <AppContext.Provider
      value={{
        ...state,
        displayAlert,
        setupUser,
        toggleSidebar,
        logoutUser,
        updateUser,
        updateProfileImage,
        handleChange,
        clearValues,

        getProducts,

        createJob,
        getJobs,
        setEditJob,
        deleteJob,
        editJob,
        showStats,
        clearFilters,
        changePage,

        addProduct,
        setProducts,

        ccPayment,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  return useContext(AppContext);
};

export { AppProvider, initialState, useAppContext };
